<template>
  <div id="app">
    <template v-if="$route.meta.requiresAuth && !isLoggedIn()">
      <LoginPage />
    </template>
    <template v-else>
      <SideNav v-if="!$route.meta.hideSideNav" />
      <router-view />
    </template>
  </div>
</template>

<script>
import SideNav from './components/SideNav.vue';
import LoginPage from './components/LoginPage.vue';

export default {
  name: 'App',
  components: {
    SideNav,
    LoginPage,
  },
  data() {
    return {
    };
  },
  methods: {
    isLoggedIn() {
      return this.$USER.secretId;
    },
  },
}
</script>

<style>
#app {
  font-family: 'VT323', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
